// frontend/packs/search.js

/* eslint-disable import/first, import/newline-after-import */

import 'global/site_header/site_header_component/site_header_component--search.css';
import 'layouts/page/searches-show.css';

// start split-test: iscroll_modal
// Keeping this here, commented out, so it can be uncommented if above split test fails
// import ResourcesGridController from 'components/resources/grid/grid-controller';
// EezyStimulusApplication.register('resources-grid', ResourcesGridController);
// end split-test: iscroll_modal

import './search-imports/sidebar-filters';

import './search-imports/search-results';

import './search-imports/search-partner';

import './search-imports/search-utils';
